<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        activeIndex: {
            type: Number,
            default: 0,
        },
    },
    name: "invoice",
    data() {
        return {
            list: [],
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {
        data: {
            immediate: true,
            handler(val) {
                if (!Array.isArray(val)) {
                    this.list = [];
                    return;
                }
                this.list = val;
            },
        },
    },
    methods: {
        // 申请发票
        applyInvoice(orderCode) {
            this.$emit('apply-invoice', orderCode);
        },
    },
};
</script>

<template>
    <div class="invoice table">
        <template v-if="activeIndex == 2">
            <div class="item thead type1 only_pc">
                <div class="tr">
                    <div class="td">订单信息</div>
                    <div class="td">开票金额</div>
                    <div class="td">发票操作</div>
                </div>
            </div>
            <div class="item type1" v-for="(item, index) in list" :key="index">
                <div class="top flex align_center">
                    <p class="code">订单号：{{item.order_code}}</p>
                </div>
                <!-- pc -->
                <div class="tr only_pc">
                    <div class="td">
                        <div class="info" v-for="(_item, _index) in item.item" :key="_index">
                            <router-link class="cover layout_bg" :style="`background-image: url(${_item.item_image});`" :to="`/shop/detail?id=${_item.item_id}`"></router-link>
                            <div class="wrapper">
                                <p class="name">
                                    <router-link :to="`/shop/detail?id=${_item.item_id}`">{{_item.item_name}}</router-link>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="td layout_flex_center">
                        <p class="price2">实际付款：RMB {{item.amount}}<br/>含运费：RMB {{ item.freight }}</p>
                    </div>
                    <div class="td layout_flex_center">
                        <div class="btn_group">
                            <div class="btn layout_flex_center" @click="applyInvoice(item.order_code)">申请发票</div>
                            <router-link class="btn layout_flex_center" :to="`/shopping/pay?code=${item.order_code}`">订单详情</router-link>
                        </div>
                    </div>
                </div>
                <!-- 移动端 -->
                <div class="only_mobile">
                    <div class="info" v-for="(_item, _index) in item.item" :key="_index">
                        <router-link class="cover layout_bg" :style="`background-image: url(${_item.item_image});`" :to="`/shop/detail?id=${_item.item_id}`"></router-link>
                        <div class="wrapper">
                            <p class="name"><router-link :to="`/shop/detail?id=${_item.item_id}`">{{_item.item_name}}</router-link></p>
                            <p class="count">x{{_item.qty}}</p>
                            <p class="price">实际付款 RMB {{item.amount}}</p>
                        </div>
                    </div>
                    <div class="btn_group">
                        <div class="btn layout_flex_center" @click="applyInvoice(item.order_code)">申请发票</div>
                        <router-link class="btn layout_flex_center" :to="`/shopping/pay?code=${item.order_code}`">订单详情</router-link>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="item thead type2 only_pc">
                <div class="tr">
                    <div class="td">订单信息</div>
                    <div class="td">开票金额</div>
                    <div class="td">发票抬头</div>
                    <div class="td">发票类型</div>
                    <div class="td">发票日期</div>
                    <div class="td">开票进度</div>
                    <div class="td">发票操作</div>
                </div>
            </div>
            <div class="item type2" v-for="(item, index) in list" :key="index">
                <div class="top flex align_center">
                    <p class="code">订单号：{{item.order_code}}</p>
                </div>
                <!-- pc -->
                <div class="tr only_pc">
                    <div class="td">
                        <div class="info" v-for="(_item, _index) in item.item" :key="_index">
                            <router-link class="cover layout_bg" :style="`background-image: url(${_item.item_image});`" :to="`/shop/detail?id=${_item.item_id}`"></router-link>
                            <div class="wrapper">
                                <p class="name">
                                    <router-link :to="`/shop/detail?id=${_item.item_id}`">{{_item.item_name}}</router-link>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="td layout_flex_center">
                        <p class="price2">实际付款：RMB {{item.amount}}<br/>含运费：RMB {{ item.freight }}</p>
                    </div>
                    <div class="td layout_flex_center text_gray">
                        <span v-if="item.invoice.type == 1">个人</span>
                        <span v-if="item.invoice.type == 2">企业</span>
                    </div>
                    <div class="td layout_flex_center text_gray">
                        <span v-if="item.invoice.invoice_type == 1">普通发票-电子</span>
                        <span v-if="item.invoice.invoice_type == 2">专用发票-电子</span>
                    </div>
                    <div class="td layout_flex_center text_gray">{{ item.invoice.created_at }}</div>
                    <div class="td layout_flex_center flex_column">
                        <p class="text_red" v-if="item.invoice.status == 0">申请中</p>
                        <template v-if="item.invoice.status == 1">
                            <p class="text_gray">已开票</p>
                            <!-- <p><a class="link_download" :href="item.invoice.file" download v-if="item.invoice.file">下载到本地</a></p> -->
                        </template>
                    </div>
                    <div class="td layout_flex_center">
                        <div class="btn_group">
                            <!-- <div class="btn layout_flex_center type1" v-if="activeIndex == 0">查看发票</div> -->
                            <div class="btn layout_flex_center type1" @click="$emit('show-detail', index)">发票详情</div>
                            <router-link class="btn layout_flex_center" :to="`/shopping/pay?code=${item.order_code}`">订单详情</router-link>
                        </div>
                    </div>
                </div>
                <!-- 移动端 -->
                <div class="only_mobile">
                    <div class="info" v-for="(_item, _index) in item.item" :key="_index">
                        <router-link class="cover layout_bg" :style="`background-image: url(${_item.item_image});`" :to="`/shop/detail?id=${_item.item_id}`"></router-link>
                        <div class="wrapper">
                            <p class="name"><router-link :to="`/shop/detail?id=${_item.item_id}`">{{_item.item_name}}</router-link></p>
                            <p class="count">x{{_item.qty}}</p>
                            <p class="price">实际付款 RMB {{_item.price}}</p>
                        </div>
                    </div>
                    <div class="btn_group">
                        <!-- <div class="btn layout_flex_center type1" v-if="activeIndex == 0">查看发票</div> -->
                        <div class="btn layout_flex_center type1" v-if="activeIndex == 1" @click="$emit('show-detail', index)">发票详情</div>
                        <router-link class="btn layout_flex_center" :to="`/shopping/pay?code=${item.order_code}`">订单详情</router-link>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<style scoped lang="scss">
@import './table.scss';
.invoice{
    .item{
        &.type1{
            .tr{
                .td{
                    &:nth-of-type(1){
                        width: 50%;
                    }
                    &:nth-of-type(2){
                        width: 30%;
                    }
                    &:nth-of-type(3){
                        width: 20%;
                    }
                }
            }
        }
        &.type2{
            .tr{
                .td{
                    &:nth-of-type(1){
                        width: 34%;
                    }
                    &:nth-of-type(2){
                        width: 16%;
                    }
                    &:nth-of-type(3),
                    &:nth-of-type(4),
                    &:nth-of-type(5),
                    &:nth-of-type(6),
                    &:nth-of-type(7){
                        width: 10%;
                    }
                }
            }
        }
        .text_gray{
            color: #999;
        }
        .text_red{
            color: #ff0000;
        }
        .link_download{
            &:hover{
                border-bottom: 1px solid var(--font_color);
            }
        }
    }
}
</style>